module.exports = __webpack_public_path__ + "media/images/ready/icon-message-76b62dc6e00dad6bc052c57f2b052360.svg";